// d88a0b5e33a0fc9e3ecff4452e7a717a9acf33cd|kind=parser-js|name=OkResponseWrappingCountryList|schemaHash=9873ef5e1089f7ef78783aaa92f9a77022943a7a

import { setDefinedValue } from '@myre/common-primitives';

import { parseCountryFromJSON, parseCountryToJSON } from './Country';
import { parseResponseMetaFromJSON, parseResponseMetaToJSON } from './ResponseMeta';

export function parseOkResponseWrappingCountryListFromJSON(
  _data,
) {
  if (!_data) {
    return _data;
  }

  const result = {};

  setDefinedValue(
    result,
    'meta',
    parseResponseMetaFromJSON(
      _data.meta
    ),
  );
  setDefinedValue(
    result,
    'content',
    Array.isArray(_data.content)
      ? _data.content.map(item =>
          parseCountryFromJSON(item),
        )
      : _data.content,
  );
  setDefinedValue(result, 'status', _data.status);

  return result;
}

export function parseOkResponseWrappingCountryListToJSON(
  _data,
) {
  if (!_data) {
    return _data;
  }

  const result = {};

  setDefinedValue(
    result,
    'meta',
    parseResponseMetaToJSON(
      _data.meta
    ),
  );
  setDefinedValue(
    result,
    'content',
    Array.isArray(_data.content)
      ? _data.content.map(item =>
          parseCountryToJSON(item),
        )
      : _data.content,
  );
  setDefinedValue(result, 'status', _data.status);

  return result;
}
